import { TCreatorApplicationSummary } from '@/types/CreatorApplication.types';
import { Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { CreatorApplicationStatusBadge, formatCreatorApplicationDate } from '../creatorApplicationDisplay';
import { InfoRow, SectionCard } from './SectionLayout';

interface Props {
  history: TCreatorApplicationSummary[];
}

const HistoryTab = ({ history }: Props) => (
  <VStack align="stretch" width="100%" gap="20px">
    <SectionCard title="Application history">
      {history.length > 0 ? (
        history.map((entry) => (
          <InfoRow
            key={entry._id}
            label={formatCreatorApplicationDate(entry.submittedAt ?? entry.updatedAt)}
          >
            <CreatorApplicationStatusBadge status={entry.status} />
          </InfoRow>
        ))
      ) : (
        <Text color="text.mediumGray">No previous applications.</Text>
      )}
    </SectionCard>
  </VStack>
);

export default HistoryTab;
